import { render, staticRenderFns } from "./Clienti.vue?vue&type=template&id=0d089728"
import script from "./Clienti.vue?vue&type=script&lang=js"
export * from "./Clienti.vue?vue&type=script&lang=js"
import style0 from "./Clienti.vue?vue&type=style&index=0&id=0d089728&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports